import React, { useEffect, useState } from "react";
import axios from "axios";
import EditKarnetModal from "./EditKarnetModal"; // Import the edit modal component
import AddOplataModal from "./AddOplataModal"; // Import the add oplata modal component
import moment from "moment";

const AllKarnets = () => {
  const [expandedRow, setExpandedRow] = useState(null);
  const token = localStorage.getItem("token"); // Pobierz token z localStorage

  const [karnety, setKarnety] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [selectedKarnet, setSelectedKarnet] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isOplataModalOpen, setIsOplataModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Number of items per page
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const [suspensionWeeks, setSuspensionWeeks] = useState(1);
  const [showSuspendModal, setShowSuspendModal] = useState(false);
  const [currentKarnet, setCurrentKarnet] = useState(null);
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [selectedKarnetHistory, setSelectedKarnetHistory] = useState(null);
  const [historyPage, setHistoryPage] = useState(1);
  const [historyData, setHistoryData] = useState(null);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    fetchKarnety();
  }, []);

  const handleDelete = async (karnet) => {
    if (window.confirm("Czy na pewno chcesz usunąć ten karnet?")) {
      try {
        await axios.delete(
          `${BACKEND_URL}/api/karnet/deleteKatnet/${karnet._id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        );
        fetchKarnety(); // Odśwież listę karnetów po usunięciu
        alert("Karnet został pomyślnie usunięty.");
      } catch (err) {
        setError("Failed to delete karnet");
      }
    }
  };

  const fetchKarnety = async () => {
    try {
      const response = await axios.get(
        `${BACKEND_URL}/api/karnet/getAllKarnety`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      setKarnety(response.data);

      // Fetch star history for each karnet
      const starHistoryPromises = response.data.map(async (karnet) => {
        const historyResponse = await axios.get(
          `${BACKEND_URL}/api/karnet/star-history/${karnet._id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        );
        return { ...karnet, starHistory: historyResponse.data };
      });

      const karnetyWithHistory = await Promise.all(starHistoryPromises);
      setKarnety(karnetyWithHistory);
      setLoading(false);
    } catch (err) {
      setError("Failed to fetch karnety");
      setLoading(false);
    }
  };

  const handleEdit = (karnet) => {
    setSelectedKarnet(karnet);
    setIsEditModalOpen(true);
  };

  const handleOplac = (karnet) => {
    setSelectedKarnet(karnet);
    setIsOplataModalOpen(true);
  };

  const handleSave = async (updatedKarnet) => {
    try {
      await axios.put(
        `${BACKEND_URL}/api/karnet/updateKarnet/${selectedKarnet._id}`,
        updatedKarnet,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      fetchKarnety(); // Refresh the list after saving
      setSuccessMessage("Karnet został pomyślnie zaktualizowany.");
      setErrorMessage("");
      setIsEditModalOpen(false);
      setTimeout(() => setSuccessMessage("") , 2000);
    } catch (err) {
      setErrorMessage("Nie udało się zaktualizować karnetu.");
      setSuccessMessage("");
      setTimeout(() => setErrorMessage("") , 2500);
    }
  };

  const handleAddOplata = async (updatedKarnet, paymentData) => {
    try {
      // Update the karnet
      await axios.put(
        `${BACKEND_URL}/api/karnet/updateKarnet/${updatedKarnet._id}`,
        updatedKarnet,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      // Add the payment record
      await axios.post(`${BACKEND_URL}/api/payment/addPayment`, paymentData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      fetchKarnety(); // Refresh the list after adding oplata
    } catch (err) {
      console.error(
        "Error adding oplata:",
        err.response ? err.response.data : err.message
      );
      setError("Failed to add oplata");
    }
  };

  const openSuspendModal = (karnet) => {
    setCurrentKarnet(karnet);
    setSuspensionWeeks(1); // Reset to default value
    setShowSuspendModal(true);
  };

  const handleSuspendKarnet = async () => {
    if (suspensionWeeks < 1) {
      alert("Czas zawieszenia musi być co najmniej 1 tydzień.");
      return;
    }

    try {
      await axios.post(
        `${BACKEND_URL}/api/karnet/suspend/${currentKarnet._id}`,
        {
          suspensionWeeks,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      fetchKarnety(); // Refresh the list after suspending
      alert("Karnet zawieszony pomyślnie.");
      setShowSuspendModal(false);
    } catch (err) {
      setError("Failed to suspend karnet");
    }
  };

  const handleShowHistory = (karnet) => {
    setSelectedKarnetHistory(karnet);
    setShowHistoryModal(true);
    setHistoryLoading(true);
    fetchKarnetHistory(karnet._id, 1);
  };

  const fetchKarnetHistory = async (karnetId, page) => {
    setHistoryLoading(true);
    try {
      const response = await axios.get(
        `${BACKEND_URL}/api/treningi/getTreningiByKarnetId/${karnetId}?page=${page}&limit=5`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      setHistoryData(response.data);
      setHistoryPage(page);
    } catch (err) {
      console.error("Failed to fetch karnet history:", err);
    } finally {
      setHistoryLoading(false);
    }
  };

  const fetchAllKarnetHistory = async (karnetId) => {
    setHistoryLoading(true);
    try {
      const response = await axios.get(
        `${BACKEND_URL}/api/treningi/getAllTreningiByKarnetId/${karnetId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      // Format the response to match the expected structure
      setHistoryData({
        treningi: response.data.treningi,
        totalPages: 1,
        currentPage: 1,
        totalItems: response.data.totalItems
      });
      setHistoryPage(1);
    } catch (err) {
      console.error("Failed to fetch all karnet history:", err);
    } finally {
      setHistoryLoading(false);
    }
  };

  // Filter karnety based on search term
  const filteredKarnety = karnety.filter((karnet) => {
    const fullName = `${karnet.uzytkownik_id?.imie || ""} ${
      karnet.uzytkownik_id?.nazwisko || ""
    }`.toLowerCase();
    return fullName.includes(searchTerm.toLowerCase());
  });

  // Calculate total pages
  const totalPages = Math.ceil(filteredKarnety.length / itemsPerPage);

  // Get current karnety for the current page
  const indexOfLastKarnet = currentPage * itemsPerPage;
  const indexOfFirstKarnet = indexOfLastKarnet - itemsPerPage;
  const currentKarnety = filteredKarnety.slice(
    indexOfFirstKarnet,
    indexOfLastKarnet
  );

  if (loading) return <p>Ładowanie karnetów...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div className="p-4 max-w-6xl mx-auto bg-white rounded-lg shadow-lg">
      {/* Komunikaty globalne */}
      {successMessage && (
        <div className="mb-4 p-2 bg-green-100 text-green-800 rounded text-center">
          {successMessage}
        </div>
      )}
      {errorMessage && (
        <div className="mb-4 p-2 bg-red-100 text-red-800 rounded text-center">
          {errorMessage}
        </div>
      )}
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold text-gray-800">Wszystkie Karnety</h1>
        <input
          type="text"
          placeholder="Szukaj..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="border border-gray-300 rounded-lg p-2 w-64 focus:ring-2 focus:ring-blue-500"
        />
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border-collapse">
          <thead>
            <tr className="bg-gray-100">
              <th className="border-b px-4 py-2 text-left text-sm font-semibold text-gray-700">
                Użytkownik
              </th>
              <th className="border-b px-4 py-2 text-left text-sm font-semibold text-gray-700">
                Status
              </th>
              <th className="border-b px-4 py-2 text-left text-sm font-semibold text-gray-700">
                Cena/Opłacono
              </th>
              <th className="border-b px-4 py-2 text-left text-sm font-semibold text-gray-700">
                Notatka
              </th>
              <th className="border-b px-4 py-2 text-left text-sm font-semibold text-gray-700">
                Historia gwiazdek
              </th>
              <th className="border-b px-4 py-2 text-center text-sm font-semibold text-gray-700">
                Akcje
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {currentKarnety.map((karnet) => (
              <React.Fragment key={karnet._id}>
                <tr className="hover:bg-gray-50">
                  <td className="px-4 py-2">
                    <div className="font-medium">
                      {karnet.uzytkownik_id?.imie}{" "}
                      {karnet.uzytkownik_id?.nazwisko}
                    </div>
                    <div className="text-sm text-gray-500">{karnet.nazwa}</div>
                  </td>
                  <td className="px-4 py-2">
                    <span
                      className={`px-2 py-1 rounded-full text-xs font-medium
      ${
        karnet.suspended
          ? "bg-yellow-100 text-yellow-800" // Zawieszony
          : karnet.aktywny
          ? "bg-green-100 text-green-800" // Aktywny
          : "bg-red-100 text-red-800" // Nieaktywny
      }`}
                    >
                      {karnet.suspended
                        ? "Zawieszony"
                        : karnet.aktywny
                        ? "Aktywny"
                        : "Nieaktywny"}
                    </span>
                  </td>
                  <td className="px-4 py-2">
                    <div className="text-sm">
                      <span className="font-medium">{karnet.cena} PLN</span>
                      <span className="text-gray-500">
                        {" "}
                        / {karnet.karnet_oplacone} PLN
                      </span>
                    </div>
                  </td>
                  <td className="px-4 py-2">
                    <div className="text-sm">{karnet.notatka}</div>
                  </td>
                  <td className="px-4 py-2">
                    <div className="text-sm">
                      {karnet.starHistory && karnet.starHistory.map((entry) => (
                        <div key={entry.month}>
                          {entry.month}: {entry.stars} gwiazdek
                        </div>
                      ))}
                    </div>
                  </td>
                  <td className="px-4 py-2 text-center">
                    <div className="flex justify-center space-x-1">
                      <button
                        onClick={() =>
                          setExpandedRow(
                            expandedRow === karnet._id ? null : karnet._id
                          )
                        }
                        className="p-1 rounded-md hover:bg-gray-100"
                        title="Szczegóły"
                      >
                        <svg
                          className="w-5 h-5 text-gray-500"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                      </button>
                      <button
                        onClick={() => handleEdit(karnet)}
                        className="p-1 rounded-md hover:bg-gray-100"
                        title="Edytuj"
                      >
                        <svg
                          className="w-5 h-5 text-blue-500"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                          />
                        </svg>
                      </button>
                      <button
                        onClick={() => handleOplac(karnet)}
                        className="p-1 rounded-md hover:bg-gray-100"
                        title="Opłać"
                      >
                        <svg
                          className="w-5 h-5 text-green-500"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
                          />
                        </svg>
                      </button>
                      <button
                        onClick={() => openSuspendModal(karnet)}
                        className="p-1 rounded-md hover:bg-gray-100"
                        title="Zawieś"
                      >
                        <svg
                          className="w-5 h-5 text-yellow-500"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                      </button>
                      <button
                        onClick={() => handleDelete(karnet)}
                        className="p-1 rounded-md hover:bg-gray-100"
                        title="Usuń"
                      >
                        <svg
                          className="w-5 h-5 text-red-500"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                          />
                        </svg>
                      </button>
                      <button
                        onClick={() => handleShowHistory(karnet)}
                        className="p-1 rounded-md hover:bg-gray-100"
                        title="Historia"
                      >
                        <svg
                          className="w-5 h-5 text-purple-500"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
                {expandedRow === karnet._id && (
                  <tr className="bg-gray-50">
                    <td colSpan="4" className="px-4 py-3">
                      <div className="grid grid-cols-3 gap-3 text-sm">
                        <div className="bg-white p-2 rounded-md shadow-sm">
                          <div className="flex justify-between">
                            <span className="text-gray-500">
                              Data rozpoczęcia:
                            </span>
                            <span className="font-medium">
                              {new Date(
                                karnet.data_rozpoczecia
                              ).toLocaleDateString("pl-PL")}
                            </span>
                          </div>
                          <div className="flex justify-between mt-1">
                            <span className="text-gray-500">
                              Data zakończenia:
                            </span>
                            <span className="font-medium">
                              {new Date(
                                karnet.data_zakonczenia
                              ).toLocaleDateString("pl-PL")}
                            </span>
                          </div>
                        </div>
                        
                        <div className="bg-white p-2 rounded-md shadow-sm">
                          <div className="flex justify-between">
                            <span className="text-gray-500">
                              Pozostało wejść :
                            </span>
                            <span className="font-medium">
                              {karnet.ilosc_wejsc}
                            </span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-500">
                              Pozostało na zapis:
                            </span>
                            <span className="font-medium">
                              {karnet.ilosc_wejsc_kal}
                            </span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-500">
                              Wykonanych treningów:
                            </span>
                            <span className="font-medium">
                              {karnet.completed_trainings || 0}
                            </span>
                          </div>
                          <div className="flex justify-between mt-1">
                            <span className="text-gray-500">Gwiazdki:</span>
                            <span className="font-medium">
                              {karnet.max_gwiazdek}
                            </span>
                          </div>
                        </div>
                        {karnet.platnosc_rodzaj === "rata" && (
  <div className="bg-white p-2 rounded-md shadow-sm">
    <div className="flex justify-between">
      <span className="text-gray-500">Ile rat do zapłacenia:</span>
      <span className="font-medium">
        {karnet.ilosc_rat}
      </span>
    </div>
    <div className="flex justify-between mt-1">
      <span className="text-gray-500">
        Oczekiwana ilość rat:
      </span>
      <span className="font-medium">
  {karnet.przypomnienie_platnosc && karnet.completed_trainings
    ? Math.min(
        Math.floor((karnet.completed_trainings + 2) / karnet.przypomnienie_platnosc) + 1,
        Math.ceil(karnet.cena / karnet.cena_za_rate)
      )
    : 0}
</span>
    </div>
    <div className="flex justify-between mt-1">
      <span className="text-gray-500">
        Max ilość rat:
      </span>
      <span className="font-medium">
       {Math.ceil(karnet.cena / karnet.cena_za_rate)}
      </span>
    </div>
    <div className="flex justify-between mt-1">
      <span className="text-gray-500">Rata:</span>
      <span className="font-medium">
        {karnet.cena_za_rate} PLN
      </span>
    </div>
  </div>
)}
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>

      {/* Paginacja */}
      <div className="flex justify-between items-center mt-4">
        <button
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
          className="px-3 py-1 rounded-lg bg-blue-500 text-white text-sm disabled:bg-gray-300 disabled:cursor-not-allowed"
        >
          ← Poprzednia
        </button>
        <span className="text-sm text-gray-600">
          Strona {currentPage} z {totalPages}
        </span>
        <button
          onClick={() =>
            setCurrentPage((prev) => Math.min(prev + 1, totalPages))
          }
          disabled={currentPage === totalPages}
          className="px-3 py-1 rounded-lg bg-blue-500 text-white text-sm disabled:bg-gray-300 disabled:cursor-not-allowed"
        >
          Następna →
        </button>
      </div>

      {/* Modale */}
      <EditKarnetModal
        isOpen={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
        karnet={selectedKarnet}
        onSave={handleSave}
      />
      <AddOplataModal
        isOpen={isOplataModalOpen}
        onClose={() => setIsOplataModalOpen(false)}
        karnet={selectedKarnet}
        onAddOplata={handleAddOplata}
      />

      {showSuspendModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-5 rounded shadow-lg">
            <h2 className="text-xl font-semibold">Zawieś Karnet</h2>
            <p>Minimalny okres: 1 tydzień</p>
            <input
              type="number"
              value={suspensionWeeks}
              onChange={(e) => setSuspensionWeeks(Number(e.target.value))}
              min="1"
              className="border rounded p-2 w-full"
            />
            <div className="flex justify-end mt-4">
              <button
                onClick={() => setShowSuspendModal(false)}
                className="mr-2 text-gray-500"
              >
                Anuluj
              </button>
              <button
                onClick={handleSuspendKarnet}
                className="bg-blue-500 text-white px-4 py-2 rounded"
              >
                Zawieś
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Historia treningów Modal */}
      {showHistoryModal && selectedKarnetHistory && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg p-6 w-full max-w-2xl">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold">
                Historia treningów - {selectedKarnetHistory.uzytkownik_id?.imie}{" "}
                {selectedKarnetHistory.uzytkownik_id?.nazwisko}
              </h2>
              <button
                onClick={() => setShowHistoryModal(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                ✕
              </button>
            </div>

            {historyLoading ? (
              <div className="flex justify-center items-center py-8">
                <svg
                  className="animate-spin h-8 w-8 text-purple-500"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
              </div>
            ) : historyData && (
              <>
                <div className="overflow-x-auto">
                  <table className="min-w-full">
                    <thead>
                      <tr className="bg-gray-100">
                        <th className="px-4 py-2 text-left">Data</th>
                        <th className="px-4 py-2 text-left">Godzina</th>
                        <th className="px-4 py-2 text-left">Trener</th>
                        <th className="px-4 py-2 text-left">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {historyData.treningi.map((trening) => (
                        <tr key={trening._id} className="border-b">
                          <td className="px-4 py-2">
                            {moment(trening.data).format("YYYY-MM-DD")}
                          </td>
                          <td className="px-4 py-2">
                            {new Date(trening.godzina_start).toLocaleTimeString("pl-PL", {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: false,
                            })}
                          </td>
                          <td className="px-4 py-2">
                            {trening.trener_id?.imie} {trening.trener_id?.nazwisko}
                          </td>
                          <td className="px-4 py-2">
                            <span
                              className={`px-2 py-1 rounded ${
                                trening.status === "completed"
                                  ? "bg-green-100 text-green-800"
                                  : trening.status === "anulowany"
                                  ? "bg-red-100 text-red-800"
                                  : "bg-yellow-100 text-yellow-800"
                              }`}
                            >
                              {trening.status === "completed"
                                ? "Zakończony"
                                : trening.status === "anulowany"
                                ? "Anulowany"
                                : "Zaplanowany"}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Pagination controls */}
                <div className="flex justify-center mt-4 space-x-2">
                  <button
                    onClick={() =>
                      fetchKarnetHistory(selectedKarnetHistory._id, historyPage - 1)
                    }
                    disabled={historyPage === 1}
                    className={`px-3 py-1 rounded ${
                      historyPage === 1
                        ? "bg-gray-300 cursor-not-allowed"
                        : "bg-blue-500 text-white hover:bg-blue-600"
                    }`}
                  >
                    Poprzednia
                  </button>
                  <span className="px-3 py-1">
                    Strona {historyPage} z {historyData.totalPages}
                  </span>
                  <button
                    onClick={() =>
                      fetchKarnetHistory(selectedKarnetHistory._id, historyPage + 1)
                    }
                    disabled={historyPage === historyData.totalPages}
                    className={`px-3 py-1 rounded ${
                      historyPage === historyData.totalPages
                        ? "bg-gray-300 cursor-not-allowed"
                        : "bg-blue-500 text-white hover:bg-blue-600"
                    }`}
                  >
                    Następna
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default AllKarnets;
